export default "__VITE_ASSET__B$XFBSS1__"